import React from "react";
import HeaderAdmin from "./HeaderAdmin";
import HeaderLanding from "./HeaderLanding";
import Tail from "./Tail";

const PublicPageWrapper = ({ authenticated, user, logout, pageName, children }) => {
  return (
    <>
      {authenticated ? (
        <HeaderAdmin page_name={pageName} isAuthenticated={authenticated} onLogout={logout} user={user} />
      ) : (
        <HeaderLanding />
      )}
      {children}
      <Tail />
    </>
  );
};

export default PublicPageWrapper;
